<template>
    <div class="report__dashboard_show">
        <div class="report__dashboard_show_header">
            <view-actions
                :title="'Dashboard'"
                :cancel-button-active="false"
                :submit-button-active="false"
            />
        </div>
        <div class="report__dashboard_show_tabs">
            <div class="container">
                <div class="columns is-variable is-0">
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-dashboard-view-digital-learning'"
                            :theme="'nav'"
                            :size="'medium'"
                            :secondary-theme="routeQueryView === 'digital-learning' ? 'primary' : ''"
                            @click="switchView('digital-learning')"
                        >Digital learning
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-dashboard-view-system-usage'"
                            :theme="'nav'"
                            :size="'medium'"
                            :secondary-theme="routeQueryView === 'system-usage' ? 'primary' : ''"
                            @click="switchView('system-usage')"
                        >System usage
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-dashboard-view-learning-activity'"
                            :theme="'nav'"
                            :size="'medium'"
                            :secondary-theme="routeQueryView === 'learning-activity' ? 'primary' : ''"
                            @click="switchView('learning-activity')"
                        >Learning activity
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'report-dashboard-view-course-completion-overview'"
                            :theme="'nav'"
                            :size="'medium'"
                            :secondary-theme="routeQueryView === 'course-completion-overview' ? 'primary' : ''"
                            @click="switchView('course-completion-overview')"
                        >Course completion overview
                        </component-button>
                    </div>
                    <div class="column"></div>
                </div>
            </div>
        </div>
        <div class="report__dashboard_show_main">
            <template v-if="routeQueryView === 'digital-learning'">
                <report-dashboard-show-digital-learning></report-dashboard-show-digital-learning>
            </template>
            <template v-else-if="routeQueryView === 'system-usage'">
                <report-dashboard-show-system-usage></report-dashboard-show-system-usage>
            </template>
            <template v-else-if="routeQueryView === 'learning-activity'">
                <report-dashboard-show-learning-activity></report-dashboard-show-learning-activity>
            </template>
            <template v-else-if="routeQueryView === 'course-completion-overview'">
                <report-dashboard-show-course-completion-overview></report-dashboard-show-course-completion-overview>
            </template>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ReportDashboardShowDigitalLearning from '@/components/ebs/reports/dashboard/show/ReportDashboardShowDigitalLearning'
import ReportDashboardShowSystemUsage from '@/components/ebs/reports/dashboard/show/ReportDashboardShowSystemUsage'
import ReportDashboardShowLearningActivity from '@/components/ebs/reports/dashboard/show/ReportDashboardShowLearningActivity'
import ReportDashboardShowCourseCompletionOverview from '@/components/ebs/reports/dashboard/show/ReportDashboardShowCourseCompletionOverview'

export default {
  name: 'report-dashboard-show',
  components: {
    ReportDashboardShowCourseCompletionOverview,
    ReportDashboardShowLearningActivity,
    ReportDashboardShowSystemUsage,
    ReportDashboardShowDigitalLearning,
    ComponentButton,
    ViewActions
  },
  data () {
    return {
      rerenderIndex: 0
    }
  },
  computed: {
    routeQueryView () {
      return this.$route.query.view
    }
  },
  watch: {
    routeQueryView () {
      this.rerenderIndex++
    }
  },
  methods: {
    switchView (value) {
      this.$router.push({ query: { view: value } })
    },
    initializeRouteQuery () {
      if (!this.routeQueryView) {
        this.switchView('digital-learning')
      }
    },
    clearReportDashboardFilters () {
      this.$store.dispatch('ebsReportDashboardClearData')
      this.$store.dispatch('ebsReportDashboardClearFilters')
    }
  },
  created () {
    this.initializeRouteQuery()
    this.clearReportDashboardFilters()
  },
  updated () {
    this.initializeRouteQuery()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboard.scss";
</style>
